enum BookTypeEnum
{
    Edition = 'Edition', // edice
    Dictionary = 'Dictionary', // slovník
    Grammar = 'Grammar', // mluvnice
    ProfessionalLiterature = 'ProfessionalLiterature', // odborná literatura
    TextBank = 'TextBank', // textová banka / korpus
    BibliographicalItem = 'BibliographicalItem',
    CardFile = 'CardFile',
    AudioBook = 'AudioBook'
}

export {
    BookTypeEnum,
}
